import { computed } from '@ember/object';
import { attr, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

const REASON_MAP = {
  reasonAvailability: 'Not available during that time',
  reasonLocation: 'Location doesn\'t work for me',
  reasonRate: 'Rate too low',
  reasonServices: 'Doesn\'t match with my offered services',
  reasonPreference: 'Doesn\'t match with my desired work',
  reasonClient: 'Don\'t want to work with this client',
  reasonOther: 'Other',
};

const REASON_PROPS = Object.keys(REASON_MAP);

/** @module */
const AssignmentUserMetum = ShModel.extend({
  favorite: attr('boolean', { defaultValue: false }),
  notInterested: attr('boolean', { defaultValue: false }),

  reasonOther: attr('boolean', { defaultValue: false }),
  reasonAvailability: attr('boolean', { defaultValue: false }),
  reasonLocation: attr('boolean', { defaultValue: false }),
  reasonRate: attr('boolean', { defaultValue: false }),
  suggestedRateAmount: attr('number'),
  suggestedRateType: attr('number'),
  reasonServices: attr('boolean', { defaultValue: false }),
  reasonPreference: attr('boolean', { defaultValue: false }),
  reasonClient: attr('boolean', { defaultValue: false }),

  notInterestedText: attr('string', { defaultValue: null }),

  notInterestedReasons: computed(...REASON_PROPS, function () {
    const reasons = REASON_PROPS.reduce((accum, prop) => {
      if (this[prop]) {
        accum.push(REASON_MAP[prop]);
      }

      return accum;
    }, []);

    return reasons.join(' • ');
  }),

  notInterestedReasonString: computed(...REASON_PROPS, 'notInterestedText', function() {
    const reasons = REASON_PROPS.reduce((accum, prop) => {
      if (!this.get(prop)) {
        return accum;
      }

      const message = (prop === 'reasonOther') ?
        `${REASON_MAP[prop]}: ${this.get('notInterestedText')}` :
        REASON_MAP[prop];

      accum.push(message);
      return accum;
    }, [ ]);

    return reasons.join(' • ');
  }),

  user: belongsTo('user', { async: false }),
});

export default AssignmentUserMetum;
